import Datatable from "./datatable_controller";

// Connects to data-controller="responses-datatable"
// The Responses tab: a question picker that reloads the table scoped to one
// question (or all), a global search, and a CSV export that follows the picker.
export default class extends Datatable {
  static values = {
    questionId: String,
    exportUrl: String,
  };

  static targets = ["table", "emptyMsg", "searchInput", "questionSelect", "exportLink"];

  // Append the selected question to every datatable request so the server scopes
  // the merged ticket+order responses to that question (blank = all questions).
  manipulateData(data) {
    if (this.hasQuestionSelectTarget) {
      this.questionIdValue = this.questionSelectTarget.value || "";
    }
    if (this.questionIdValue) data["question_id"] = this.questionIdValue;
    return data;
  }

  // Picker change → reload the table and re-point the export link.
  selectQuestion() {
    this.questionIdValue = this.questionSelectTarget.value || "";
    this.updateExportLink();
    if (this.dataTable) this.dataTable.ajax.reload();
  }

  // Keep the Export CSV link in sync with the current question selection so the
  // download follows what's on screen (per-question vs the wide "all questions").
  updateExportLink() {
    if (!this.hasExportLinkTarget) return;
    const base = this.exportUrlValue;
    const url = this.questionIdValue
      ? `${base}${base.includes("?") ? "&" : "?"}question_id=${encodeURIComponent(this.questionIdValue)}`
      : base;
    this.exportLinkTarget.setAttribute("href", url);
  }

  get columns() {
    return [
      { data: "respondent", orderable: false },
      { data: "email", orderable: false },
      { data: "ticket_or_order", orderable: false },
      { data: "answer", orderable: false },
      { data: "submitted", orderable: false },
    ];
  }

  get ordering() {
    return false;
  }

  get searching() {
    return true;
  }
}
